// Resumen de la tienda para «Mi tienda» (`GET /seller/store-summary`). El silo acota la tienda al
// scope del token, así que la pantalla no manda ninguna: solo elige el rango.
import { useQuery } from '@tanstack/react-query';
import { wizardApi } from '@/api/services/retail-wizard';
import type { StoreSummary, StoreSummaryRange } from '@/api/services/retail-wizard/contract';

/**
 * Un query por rango: cambiar de chip cambia la clave, así que volver a «Hoy» pinta de cache en vez
 * de esperar otra vuelta al silo. Sin datos de muestra — si la lectura falla, la pantalla lo dice.
 */
export function useStoreSummary(range: StoreSummaryRange) {
    return useQuery<StoreSummary>({
        queryKey: ['sales', 'store-summary', range],
        queryFn: () => wizardApi.getStoreSummary(range),
        staleTime: 60_000,
    });
}
